import { FC } from 'react';
import Loading from '../../../../components/Loading/Loading';
import Modal from '../../../../components/Modal/Modal';
import { BatchProgressModalProps } from './BatchProgressModal.types';
import {
  KeepOpenHint,
  MenuCount,
  ProgressContent,
  ProgressFill,
  ProgressTrack,
  StatusRow,
} from './BatchProgressModal.styles';

const BatchProgressModal: FC<BatchProgressModalProps> = ({ open, completed, total, menusSubmitted, menusTotal }) => {
  const percent = total > 0 ? Math.round((completed / total) * 100) : 0;
  // While running, surface the batch currently in flight; once everything is done, show the final count.
  const currentBatch = completed < total ? completed + 1 : total;

  return (
    <Modal
      id='changeMenuSpecsBatchProgress'
      open={open}
      onClose={() => {}}
      title='Updating Menu Specs'
      hideCloseButton
      bodyWidth={448}
    >
      <ProgressContent data-testid='BatchProgressModalContent'>
        <StatusRow>
          <Loading size={20} />
          <span>
            Processing batch {currentBatch} of {total}
          </span>
        </StatusRow>
        <ProgressTrack role='progressbar' aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100}>
          <ProgressFill style={{ width: `${percent}%` }} />
        </ProgressTrack>
        <MenuCount>
          {menusSubmitted.toLocaleString()} of {menusTotal.toLocaleString()} menus submitted
        </MenuCount>
        <KeepOpenHint>Please keep this window open until all batches are complete.</KeepOpenHint>
      </ProgressContent>
    </Modal>
  );
};

export default BatchProgressModal;
